import cx from 'classnames';
import type { FC, PropsWithChildren } from 'react';

interface Props {
  className?: string;
}

export const displayName: string = 'Design System/List';

const List: FC<PropsWithChildren<Props>> = ({ children, className }) => {
  const classNames: string = cx('border border-solid divide-y rounded border-grey-lighter divide-grey-lighter', className);

  return (
    <ul className={classNames} data-component="list">
      {children}
    </ul>
  );
};

export type { Props as ListProps };
export default List;
